import {
    SET_CURRENT_VTO,
    TOGGLE_VTO,
    SET_VTO_MESSAGE,
    RESET_VTO_MESSAGE,
} from '../actionTypes/VirtualTryOnActionTypes';

export const setCurrentVto = (payload) => ({
    type: SET_CURRENT_VTO,
    payload,
});

export const setVtoMessage = (payload) => ({
    type: SET_VTO_MESSAGE,
    payload,
});

export const resetVtoMessage = () => ({
    type: RESET_VTO_MESSAGE,
});

export const toggleVto = (payload) => ({
    type: TOGGLE_VTO,
    payload,
});
